import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import Container from '@mui/material/Container';
import { Header } from '../Header';

const DynamicTestPanel = dynamic(
  () => import('@packages/shared/src/components/TestPanel/TestPanel'),
  {
    ssr: false,
  },
);

export interface PageLayoutOrderProps {
  /** React children nodes */
  children?: ReactNode;
}
/**
 * Global PageLayout component which includes Header, PromotionBanner, and Footer
 * */
export const PageLayoutOrder = ({ children }: PageLayoutOrderProps) => (
  <>
    {typeof window !== 'undefined' && window.location.href.indexOf('empirie.dev') > 0 && (
      <DynamicTestPanel />
    )}
    <Header />
    <Container component="main" sx={{ py: 3 }}>
      {children}
    </Container>
    {/* TODO Order Footer */}
    <div />
  </>
);
